import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import { IntegratorWebhookLogs } from "@rentiohq/web-shared/dist/components";
import { Navigate } from "react-router-dom";

// Internal: the office's outgoing integrator webhooks, for Rentio monitors only. The office's
// own employees never see this tab; the API refuses them as well, so hiding it here is
// convenience rather than the access check.
export const WebhookLogs = () => {
  const { broker, isMonitor } = authHooks.useSelf();

  if (!isMonitor) {
    return <Navigate to="/company" replace={true} />;
  }

  if (!broker) {
    return null;
  }

  return <IntegratorWebhookLogs brokerId={broker.id} />;
};
